import { Battlepass } from "./Battlepass"

export interface UserProfile {
    balance: number
    experience: number
    donatePoints: number
    battlepass?: Battlepass
    userName: string
    subscription: Subscription | null
    tasks?: DailyTask[]
    online: number
}

export const areProfilesEqual = (profile1: UserProfile | null, profile2: UserProfile | null) => {
    if (profile1 === null && profile2 === null) return true
    if (profile1 === null || profile2 === null) return false

    return profile1.balance === profile2.balance &&
        profile1.experience === profile2.experience &&
        profile1.donatePoints === profile2.donatePoints &&
        profile1.userName === profile2.userName &&
        profile1.online === profile2.online &&
        profile1.subscription?.name === profile2.subscription?.name &&
        profile1.subscription?.expiresAt === profile2.subscription?.expiresAt
}

export interface Subscription {
    name: string
    expiresAt: string
}

export interface DailyTask {
    name: string
    type: 'EASY' | 'MEDIUM' | 'HARD'
    icon: string
    reward: number
    target: number
    progress: number
}
